import { ErrorHandler, Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'

/**
 * Global error handler for the application.
 *
 * This handler catches all unhandled errors and provides:
 * - Centralized error logging
 * - Error reporting to monitoring services
 * - User-friendly error handling
 *
 * Prevents silent failures that can cause white screens and other issues.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private router = inject(Router)

  handleError(error: Error | unknown): void {
    // Log detailed error information
    console.error('Global error caught:', error)

    // Log additional context
    if (error && typeof error === 'object' && 'message' in error) {
      console.error('Error message:', error.message)
    }

    if (error && typeof error === 'object' && 'stack' in error) {
      console.error('Error stack:', error.stack)
    }

    // Log current route for debugging
    console.error('Current route:', this.router.url)

    // TODO: Send error to monitoring service (e.g., Sentry, LogRocket, etc.)
    // Example:
    // this.sentryService.captureException(error)

    // TODO: Show user-friendly error notification (optional)
    // Example:
    // this.toastService.error('An unexpected error occurred. Please try refreshing the page.')

    // Re-throw the error to preserve default error handling
    // This ensures the error appears in the console and doesn't silently fail
    throw error
  }
}
